<template>
  <div class="container-fluid px-4 mt-4">
    <!-- Bütün sayfayı kaplayan loading ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>

    <div class="row" v-show="!loading">
      <div class="container">
        <vue-good-table
            mode="remote"
            @on-column-filter="onColumnFilter($event.columnFilters)"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            :rows="rows"
            :columns="columns"
            :totalRows="totalRecords"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              perPage: serverParams.perPage,
              perPageDropdown: [5, 10, 20, 50],
              dropdownAllowAll: false,
              mode: 'records',
              nextLabel: 'Sonraki',
              prevLabel: 'Önceki',
              rowsPerPageLabel: 'Sayfa başına satır',
              ofLabel: '/',
              pageLabel: 'sayfa',
              allLabel: 'Tümü'
            }"
        >
          <template #table-row="props">
            <span v-if="props.column.field === 'actions'">
              <b-button variant="info" size="sm" @click="showOrderDetails(props.row.id, props.row.totalPrice)">
                Sipariş Detaylarını Göster
              </b-button>
            </span>
            <span v-else-if="props.column.field === 'status'">
              <b-badge :variant="getStatusVariant(props.row.status)" pill style="font-size: 1rem; padding: 0.5em 0.75em;">
                {{ props.row.status }}
              </b-badge>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <!-- Modal - Sipariş Detayları -->
    <b-modal v-model="showModal" title="Sipariş Detayları" hide-footer>
      <div v-if="orderItemsLoading" class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
        <p>Ürünler yükleniyor...</p>
      </div>

      <div v-else>
        <b-table striped hover :items="orderItems" :fields="orderItemFields">
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
        </b-table>

        <!-- Sağ alt köşe: Toplam -->
        <div class="d-flex justify-content-end mt-3">
          <strong>Toplam: {{ totalOrderPrice }}</strong>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import OrderService from '../../service/OrderService';

export default {
  name: 'client-order-list',
  data() {
    return {
      rows: [],
      columns: [
        { field: 'id', hidden: true },
        { label: 'Sipariş Zamanı', field: 'orderDate', sortable: false },
        { label: 'Sipariş Tutarı', field: 'totalPrice', sortable: false },
        { label: 'Sipariş Durumu', field: 'status', sortable: false },
        { label: 'Detaylar', field: 'actions', sortable: false }
      ],
      orderItems: [],
      orderItemFields: [
        { key: 'index', label: '#' },
        { key: 'productName', label: 'Ürün Adı' },
        { key: 'quantity', label: 'Adet' },
        { key: 'priceText', label: 'Birim Fiyat' },
        { key: 'totalPriceText', label: 'Toplam Tutar' }
      ],
      showModal: false,
      loading: false,
      orderItemsLoading: false,
      totalRecords: 0,
      totalOrderPrice: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
    };
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadClientOrders(this.serverParams);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadClientOrders(this.serverParams);
    },

    onColumnFilter(params) {
      this.updateParams({ columnFilters: params });
      this.loadClientOrders(this.serverParams);
    },

    async loadClientOrders() {
      this.loading = true;
      try {
        this.serverParams.clientId = this.$store.state.clientId;
        const response = await OrderService.getClientOrders(this.serverParams);
        this.rows = response.data;
        this.totalRecords = response.total;
      } catch (error) {
        console.error("Sipariş geçmişi görüntülenirken hata oluştu:", error);
        this.$errorNotification(this, "Sipariş geçmişi görüntülenirken hata oluştu.");
      } finally {
        this.loading = false;
      }
    },

    async showOrderDetails(orderId, totalPrice) {
      this.showModal = true;
      this.orderItemsLoading = true;
      this.totalOrderPrice = totalPrice;
      try {
        this.orderItems = await OrderService.getClientOrderItems(this.$store.state.clientId, orderId);
      } catch (error) {
        console.error("Sipariş detayları yüklenirken hata oluştu:", error);
        this.$errorNotification(this, "Sipariş detayları yüklenirken hata oluştu.");
      } finally {
        this.orderItemsLoading = false;
      }
    },

    getStatusVariant(status) {
      switch (status) {
        case 'Sipariş oluşturuldu':
          return 'warning';
        case 'Sipariş onaylandı':
          return 'success';
        case 'Sipariş reddedildi':
          return 'danger';
        default:
          return 'secondary';
      }
    },
  },
  beforeMount() {
    this.loadClientOrders(this.serverParams);
  }
};
</script>

<style scoped>
.card {
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
